import { InjectionToken } from '@angular/core';
import { DEFAULT_ROUTER_FEATURENAME, routerReducer, RouterReducerState } from '@ngrx/router-store';
import { Action, ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { featureKeySignup, FeatureStateSignup, reducerSignup } from '../signup/store/signup.reducer';
import { featureKeyAuth, FeatureStateAuth, reducerAuth } from './auth/auth.reducer';

export interface State {
  [DEFAULT_ROUTER_FEATURENAME]: RouterReducerState;
  [featureKeyAuth]: FeatureStateAuth;
  [featureKeySignup]: FeatureStateSignup;
}

export const reducer = new InjectionToken<ActionReducerMap<State, Action>>('Root reducers token', {
  factory: () => ({
    [DEFAULT_ROUTER_FEATURENAME]: routerReducer,
    [featureKeyAuth]: reducerAuth,
    [featureKeySignup]: reducerSignup,
  }),
});

export const selectRouter = createFeatureSelector<RouterReducerState>(DEFAULT_ROUTER_FEATURENAME);
